import React from 'react'
import './index.scss'
import { useHistory } from "react-router-dom";


export default function NotMatch() {
  let history = useHistory();

  return (
    <div className="page404">
      <h1 className="title">你要找的页面似乎不见了</h1>
      <div className="opt-container">
        <button className="btn" onClick={() => history.goBack()}>回到上一页</button>
        <button className="btn" onClick={() => history.push('/')}>回到首页</button>
      </div>
    </div>
  )
}